import moment from 'moment';
import 'moment/locale/fr'; // Import French locale

// Set default locale to French
moment.locale('fr');

export const formatDate = (date, options = {}) => {
  if (!date) return '';

  const { format = 'medium', includeTime = false, locale = 'fr' } = options;

  try {
    // Create moment object - automatically converts to local timezone
    const momentDate = moment(date);

    // Check if date is valid
    if (!momentDate.isValid()) {
      return '';
    }

    // Set locale for this specific date
    momentDate.locale(locale);

    // Handle predefined formats
    let formatString;

    switch (format) {
      case 'short':
        formatString = includeTime ? 'DD/MM/YYYY, HH:mm' : 'DD/MM/YYYY';
        break;

      case 'medium':
        formatString = includeTime ? 'DD MMM YYYY, HH:mm' : 'DD MMM YYYY';
        break;

      case 'long':
        formatString = includeTime ? 'DD MMMM YYYY, HH:mm' : 'DD MMMM YYYY';
        break;

      case 'full':
        formatString = includeTime ? 'dddd DD MMMM YYYY, HH:mm' : 'dddd DD MMMM YYYY';
        break;

      default:
        // If format is not a predefined type, assume it's a custom moment format string
        formatString = format;
        break;
    }

    return momentDate.format(formatString);
  } catch {
    return '';
  }
};
